export default __webpack_public_path__ + "static/3_18-1c9aa10fce5685a0188c22435960e1cd.png";